//auth
export const POST_FAKE_LOGIN = '/post-fake-login';
/* export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"; */
export const POST_JWT_LOGIN = '/v1/auth/login';
export const POST_FAKE_PASSWORD_FORGET = '/fake-forget-pwd';
export const POST_FAKE_JWT_PASSWORD_FORGET = '/jwt-forget-pwd';
export const SOCIAL_LOGIN = '/social-login';
export const JWT_REGISTER = '/post-jwt-register';
export const POST_FAKE_REGISTER = '/post-fake-register';

export const USER_CHANGE_PASSWORD = '/v1/auth/changePassword';

// profile & settings
export const GET_PROFILE_DETAILS = '/v1/auth/me';
export const GET_USER_SETTINGS = '/v1/auth/me';
export const UPDATE_ETTINGS = '/update-user-settings';

// contacts
export const GET_CONTACTS = '/v1/persons';
export const CREATE_CONTACT = '/v1/persons';
export const EDIT_CONTACT = (personId: string) => `/v1/persons/${personId}`;
export const DELETE_CONTACT = (personId: string) => `/v1/persons/${personId}`;

// calls
export const GET_CALLS_LIST = '/calls-list';

// bookmarks
export const GET_BOOKMARKS_LIST = '/bookmarks-list';
export const DELETE_BOOKMARK = '/bookmarks-delete';
export const UPDATE_BOOKMARK = '/bookmarks-update';

// chats
export const GET_FAVOURITES = '/get-favourites';
export const GET_DIRECT_MESSAGES = '/v1/conversations';
export const GET_CHANNELS = '/get-channles';
export const ADD_CONTACTS = '/add-contact';
export const CREATE_CHANNEL = '/create-channel';
export const GET_CHAT_USER_DETAILS = '/v1/persons';
export const GET_CHAT_USER_MESSAGES = '/v1/conversations';
export const SEND_MESSAGE = '/v1/conversations/outbound';
export const RECEIVE_MESSAGE = '/receive-message';
export const READ_MESSAGE = '/read-message';
export const RECEIVE_MESSAGE_FROM_USER = '/receive-message-from-user';
export const DELETE_MESSAGE = '/delete-message';
export const FORWARD_MESSAGE = '/forward-message';
export const DELETE_USER_MESSAGES = '/delete-user-messages';
export const TOGGLE_FAVOURITE_CONTACT = '/toggle-favourite-contact';
export const GET_ARCHIVE_CONTACT = '/get-archive-contacts';
export const TOGGLE_ARCHIVE_CONTACT = '/toggle-archive-contact';
export const READ_CONVERSATION = '/v1/conversations';
export const DELETE_IMAGE = '/user-delete-img';

// groups
export const GET_CHANNEL_DETAILS = '/get-channel-details';
